import * as React from 'react'

import {
  Card,
  ErrorAlert,
  IconNotification,
  Space,
  IconExternalLink,
} from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import slackLogo from '@webapp/platform/integrations/assets/images/slack.png'
import { SlackUserLinkingSection } from '@webapp/platform/integrations/feature-sets/SlackUserLinkingSection'
import { NotConnectedView } from './components/NotConnectedView'
import { SlackIntegrationSectionLoader } from './components/SlackIntegrationSectionLoader'
import messages from './messages'
import { SlackIntegrationSectionStyled } from './styles/SlackIntegrationSectionStyled'
import { useSlackIntegrationSection } from './useSlackIntegrationSection'

export const SlackIntegrationSection = () => {
  // Slack documentation link for setting up the integration
  const SLACK_SETUP_HELP_URL =
    'https://success.procurify.com/en/articles/9002297-how-to-set-up-the-slack-integration-with-procurify'

  const intl = useProcurifyIntl()
  const { isIntegrated, handleConnect, isLoading, error } =
    useSlackIntegrationSection()

  const renderContent = () => {
    if (isLoading) {
      return <SlackIntegrationSectionLoader />
    }

    if (error) {
      return (
        <ErrorAlert icon={<IconNotification />}>
          {intl.formatMessage(messages.errorMessage)}
        </ErrorAlert>
      )
    }

    if (isIntegrated) {
      return <SlackUserLinkingSection />
    }

    return <NotConnectedView onConnect={handleConnect} />
  }

  return (
    <SlackIntegrationSectionStyled>
      <Card>
        <Card.Content>
          <Space direction='vertical' size='large'>
            <Space
              direction='horizontal'
              justify='space-between'
              align='center'
              size='large'
            >
              <img src={slackLogo} alt='Slack' height={36} />
              <Space
                direction='horizontal'
                size='small'
                justify='space-between'
              >
                <IconExternalLink color='textLink' />
                <a
                  href={SLACK_SETUP_HELP_URL}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  {intl.formatMessage(messages.learnHowLinkText)}
                </a>
              </Space>
            </Space>
            {renderContent()}
          </Space>
        </Card.Content>
      </Card>
    </SlackIntegrationSectionStyled>
  )
}
